import { motion } from 'framer-motion';

export function AnimatedBackground() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {/* Animated gradient mesh */}
      <div className="absolute inset-0">
        {/* Gradient blob 1 - Primary (Magenta) */}
        <motion.div
          className="absolute w-[800px] h-[800px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(214, 0, 109, 0.15) 0%, transparent 70%)',
            left: '-10%',
            top: '-20%',
          }}
          animate={{
            x: [0, 50, 0],
            y: [0, 30, 0],
            scale: [1, 1.1, 1],
          }}
          transition={{
            duration: 20,
            repeat: Infinity,
            ease: 'easeInOut',
          }}
        />

        {/* Gradient blob 2 - Accent (Green) */}
        <motion.div
          className="absolute w-[600px] h-[600px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(0, 206, 124, 0.12) 0%, transparent 70%)',
            right: '-5%',
            top: '10%',
          }}
          animate={{
            x: [0, -40, 0],
            y: [0, 50, 0],
            scale: [1, 1.15, 1],
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 2,
          }}
        />

        {/* Gradient blob 3 - Info (Turquoise) */}
        <motion.div
          className="absolute w-[500px] h-[500px] rounded-full"
          style={{
            background: 'radial-gradient(circle, rgba(3, 191, 214, 0.1) 0%, transparent 70%)',
            left: '30%',
            bottom: '-10%',
          }}
          animate={{
            x: [0, 60, 0],
            y: [0, -30, 0],
            scale: [1, 1.05, 1],
          }}
          transition={{
            duration: 22,
            repeat: Infinity,
            ease: 'easeInOut',
            delay: 4,
          }}
        />
      </div>

      {/* Floating geometric shapes with glassmorphism */}
      <motion.div
        className="absolute top-[15%] right-[15%] w-20 h-20 rounded-2xl glass"
        animate={{
          y: [0, -20, 0],
          rotate: [0, 5, 0],
        }}
        transition={{
          duration: 8,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      <motion.div
        className="absolute top-[35%] right-[25%] w-12 h-12 rounded-xl glass"
        style={{ background: 'rgba(0, 206, 124, 0.1)' }}
        animate={{
          y: [0, 15, 0],
          x: [0, -10, 0],
          rotate: [0, -8, 0],
        }}
        transition={{
          duration: 10,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1,
        }}
      />

      <motion.div
        className="absolute bottom-[25%] right-[10%] w-16 h-16 rounded-full glass"
        style={{ background: 'rgba(3, 191, 214, 0.08)' }}
        animate={{
          y: [0, -25, 0],
          scale: [1, 1.1, 1],
        }}
        transition={{
          duration: 12,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 3,
        }}
      />

      {/* Tech grid overlay */}
      <div
        className="absolute inset-0 opacity-[0.08]"
        style={{
          backgroundImage: `
            linear-gradient(rgba(214, 0, 109, 0.8) 2px, transparent 2px),
            linear-gradient(90deg, rgba(214, 0, 109, 0.8) 2px, transparent 2px)
          `,
          backgroundSize: '60px 60px',
        }}
      />

      {/* Bottom fade gradient */}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-white to-transparent" />
    </div>
  );
}
